// Official Easy Learning Academy logo. `chip` wraps it in a white rounded
// card so the navy/gold artwork stays visible on dark (navy) backgrounds.
const SIZES = { sm: "h-10", md: "h-14", lg: "h-24", xl: "h-44" };

export default function Logo({ size = "md", chip = false }) {
  const h = SIZES[size] || SIZES.md;
  const img = (
    <img
      src={`${process.env.PUBLIC_URL || ""}/logo.png`}
      alt="Easy Learning Academy"
      data-testid="brand-logo-img"
      className={`${h} w-auto object-contain`}
    />
  );
  if (chip) {
    return (
      <div data-testid="brand-logo" className="bg-white rounded-2xl px-3 py-2 shadow-md inline-flex items-center justify-center">
        {img}
      </div>
    );
  }
  return <div data-testid="brand-logo" className="inline-flex items-center">{img}</div>;
}
